package fr.xibalba.generateurClassesLycee.pages.eleves

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun Liste() {
    val ctx = rememberPageContext()
    Column {
        Box { Text("Arrive plus tard !") }
        Button({
            ctx.router.navigateTo("/agencement/niveau")
        }, Modifier.margin(top = 8.px)) {
            Text("Passer à l'étape suivante")
        }
    }
}